import { Routes, Route, useNavigate } from "react-router-dom";
import { Container, Fade, Box } from "@mui/material";
import AppBar from "../components/AppBar";
// import { SlideInContextProvider, SlideIn } from "ft-shared-graphql";
import StaffProgressPage from "./StaffProgressPage";
import ManageStaffPage from "./ManageStaffPage";
import PersonTableLink from "./PersonTableLink";
import { useSelectedPerson } from "../../context/StaffContext/StaffProvider";
const StaffPageRoutes = () => {
    const { setSelectedPerson } = useSelectedPerson();

    const navigate = useNavigate()
    const goBack = () => {
        navigate(-1)
    }
    const handleSelectedPerson = (id: string, action: string) => {
        setSelectedPerson(null)
        switch (action) {
            case "Profile":
                navigate(`/staff/manage/${id}`);
                break;
            case "Link":
                navigate(`/staff/manage/link/${id}`)
                break;

        }
    }

    return (
        <Routes>
            <Route path="/:cid" element={<StaffProgressPage onBack={goBack} onSelectedPerson={handleSelectedPerson} />} />
            <Route path="/manage/:id" element={<ManageStaffPage onBack={goBack} onLink={handleSelectedPerson} />} />
            <Route path="/manage/link/:id" element={<PersonTableLink onBack={goBack} />} />
            {/* <Route path="*" element={} */}
            {/* <Route path="/manage/:id" element={<ManageStaffPage onBack={goBack} onLink={handleSelectedPerson} />} /> */}
        </Routes>
    )
}

export const StaffRoutes = () => {
    return (
        <>
            {/* <SlideInContextProvider> */}
                <AppBar />
                {/* <SlideIn /> */}

                <Fade appear in timeout={500}>
                    <Container maxWidth="xl">
                        <Box component="div" sx={{ paddingTop: "40px", paddingBottom: "32px" }}>
                            <StaffPageRoutes />
                        </Box>
                    </Container>
                </Fade>
            {/* </SlideInContextProvider> */}
        </>
    )
}